import { PageController } from '@client/components/_core/layout/PageController';
import { NoteEdit } from '@client/components/claims/NoteEdit';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/console/$orgId/compliance/complaints/details/$id/manage/note/add')({
    staticData: { presentation: 'overlay' },
    component: NoteAdd,
});

function NoteAdd() {
    const { id } = Route.useParams();
    const orgId = useOrgId();
    const navigate = useNavigate();

    const [open, setOpen] = useState(true);

    return (
        <PageController route={Route}>
            <NoteEdit
                entityId={id}
                entity="complaint"
                open={open}
                type="NOTE"
                title="Add note"
                onClose={() => {
                    setOpen(false);

                    navigate({
                        to: '/console/$orgId/compliance/complaints/details/$id/manage',
                        params: {
                            orgId,
                            id,
                        },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
